<template>
  <div>
    <div v-if="authority" :bordered="false">
      <div v-if="isShowSignType && !contracts.length">
        <InfoBox v-if="signData.realNameStatus !== null" :show-line="false" title="签约状态" class="profile-info infoStyle">
        <template>
          <div class="sign_div">
            <a-spin :spinning="spinning">
              <img :src="imgList[signData.electronicContractStatus]" alt="">
              <span class="text_ok">{{ signText[signData.electronicContractStatus] }}</span>
              <a-button v-if="signData.electronicContractStatus === contractStatus.ONLINE_SIGN" class="text_btn" @click="onLook">
                查看电子合同
              </a-button>
              <a-button v-if="signData.electronicContractStatus === contractStatus.CAN_SIGN" class="text_btn" @click="toSign">
                去签约
              </a-button>
            </a-spin>
          </div>
        </template>
      </InfoBox>
      </div>
      <InfoBox title="基本信息" :show-line="false" class="profile-info infoStyle text_div" bordered :column="isEnterprise?3:2" size="middle" :label-col="{span: 3}" :wrapper-col="{span: 16}">
        <template v-if="!isEnterprise" slot="mainContent">
          <a-descriptions-item label="企业简称">{{baseInfo.customerName ? baseInfo.customerName : baseInfo.corpName || '--'}}</a-descriptions-item>
          <a-descriptions-item label="类型">{{baseInfo.customerType || '--'}}</a-descriptions-item>
          <a-descriptions-item label="企业名称">{{baseInfo.corpName || '--'}}</a-descriptions-item>
          <a-descriptions-item label="社会信用代码">{{baseInfo.creditCode || '--'}}</a-descriptions-item>
          <a-descriptions-item label="联系人">{{baseInfo.contacts || '--'}}</a-descriptions-item>
          <a-descriptions-item label="联系电话">{{baseInfo.telPhone || '--'}}</a-descriptions-item>
          <a-descriptions-item label="联系地址" :span="2">{{getCustomerAddress(baseInfo) || '--'}}</a-descriptions-item>
          <a-descriptions-item v-if="signData.realNameStatus !== null" label="法定代表人身份证号">{{authMessage?authMessage.legalIdNum:'--'}}</a-descriptions-item>
          <a-descriptions-item v-if="signData.realNameStatus !== null" label="法定代表人">{{authMessage?authMessage.legalPerson:'--'}}</a-descriptions-item>
          <a-descriptions-item v-if="signData.realNameStatus !== null" label="法定代表人手机">{{authMessage?authMessage.legalMobile:'--'}}</a-descriptions-item>
          <a-descriptions-item label="营业执照名称" :span="2">
            <div>
              <el-image 
                v-if="baseInfo.ext && baseInfo.ext.businessLicenseUrl"
                class="imgBox"
                :src="baseInfo.ext.businessLicenseUrl" 
                fit="contain"
                :preview-src-list="[baseInfo.ext.businessLicenseUrl]">
              </el-image>
              <span v-else>--</span>
            </div>
          </a-descriptions-item>
        </template>
        <template v-else slot="mainContent">
          <a-descriptions-item label="企业名称">{{baseInfo.corpName}}</a-descriptions-item>
          <a-descriptions-item label="统一社会信用代码">{{baseInfo.creditCode}}</a-descriptions-item>
          <a-descriptions-item label="企业类型">{{baseInfo.corpType}}</a-descriptions-item>
          <a-descriptions-item label="法人">{{baseInfo.legalPersonName}}</a-descriptions-item>
          <a-descriptions-item label="成立日期">{{baseInfo.fromDeadlineDate?formatDate(baseInfo.fromDeadlineDate):''}}</a-descriptions-item>
          <a-descriptions-item label="营业期限">{{baseInfo.toDeadlineDate?formatDate(baseInfo.toDeadlineDate):'无限期'}}</a-descriptions-item>
          <a-descriptions-item label="住所">{{baseInfo.registrationAddress}}</a-descriptions-item>
          <a-descriptions-item label="营业执照" :span="2">
            <div>
              <el-image 
                v-if="baseInfo.ext && baseInfo.ext.businessLicenseUrl"
                class="imgBox"
                :src="baseInfo.ext.businessLicenseUrl" 
                fit="contain"
                :preview-src-list="[baseInfo.ext.businessLicenseUrl]">
              </el-image>
            </div>
          </a-descriptions-item>
        </template>
      </InfoBox>
      <div v-for="(contract, index) in contracts" :key="contract.contractResp.id" class="profile-info">
        <!-- <a-divider class="dividerMargin" /> -->
        <InfoBox :title="`合同信息${index+1}`" :show-line="false" :image="true" class="infoStyle" bordered :column="2">
          <template slot="mainContent">
            <a-descriptions-item label="合同名称">{{contract.contractResp.name}}</a-descriptions-item>
            <a-descriptions-item label="合同有效期">{{contract.contractResp.closeTime | formatTimestamp}}</a-descriptions-item>
            <a-descriptions-item label="甲方名称">{{contract.contractResp.partATenantName}}</a-descriptions-item>
            <a-descriptions-item label="乙方名称">{{contract.contractResp.partBTenantName}}</a-descriptions-item>
            <a-descriptions-item label="状态">{{ContractStatusText[contract.contractResp.status]}}</a-descriptions-item>
          </template>
        </InfoBox>
        <!-- <a-divider class="dividerMargin" /> -->
        <InfoBox title="开票信息" :show-line="false">
          <template>
            <a-table
              row-key="id"
              class="profile-table table-sigle"
              :scroll="{ x: 'calc(1200px + 50%)'}"
              :columns="ticketColumns"
              :data-source="contract.settlementDetailResp.invoiceDetails"
              :pagination="false"
            >
              <template
                v-for="col in ['titles', 'taxPayerId', 'accountName', 'accountBank', 'account', 'address']"
                :slot="col"
                slot-scope="text"
              >
                <div :key="col">
                  <a-tooltip placement="top">
                    {{text}}
                    <template slot="title">{{ text }}</template>
                  </a-tooltip>
                </div>
              </template>
            </a-table>
          </template>
        </InfoBox>
        <InfoBox title="税率信息" :show-line="false">
          <template>
            <a-row>
              <a-col :span="11" >
                <a-table
                  class="profile-table table-sigle"
                  :columns="taxRateColumns"
                  :data-source="filterData(contract.contractTaxRateResp.details.costTaxRates, true)"
                  :pagination="false"
                />
              </a-col>
              <a-col :span="11" :offset="1">
                <a-table
                  class="profile-table"
                  :columns="taxRateColumns"
                  :data-source="filterData(contract.contractTaxRateResp.details.costTaxRates, false)"
                  :pagination="false"
                />
              </a-col>
            </a-row>
          </template>
        </InfoBox>
      </div>
    </div>
    <div v-else class="noAuthority">
      <a-row>
        <a-col :span="6">
          <a-row>
            <a-col class="tr" :span="8">姓名：</a-col>
            <a-col class="tl" :span="12">{{baseInfo.customerName}}</a-col>
          </a-row>
        </a-col>
        <a-col :span="6">
          <a-row>
            <a-col class="tr" :span="8">货主编码：</a-col>
            <a-col class="tl" :span="12">{{baseInfo.customerCode}}</a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="6">
          <a-row>
            <a-col class="tr" :span="8">手机号：</a-col>
            <a-col class="tl" :span="12">{{baseInfo.telPhone}}</a-col>
          </a-row>
        </a-col>
        <a-col :span="6">
          <a-row>
            <a-col class="tr" :span="8">身份证号：</a-col>
            <a-col class="tl" :span="12">{{baseInfo.ext && baseInfo.ext.identityNo}}</a-col>
          </a-row>
        </a-col>
      </a-row>
    </div>
    <!-- 查看合同 -->
    <a-modal v-model="visible" class="contractStyle" width="880px" :footer="null" :mask-closable="false">
      <div slot="title">
        <p><span class="text_title">运荔枝网络货运电子合同</span></p>
      </div>
      <div class="contractBox">
        <div class="text">
          <iframe :src="iframeUrl" frameborder="0"></iframe>
        </div>
        <div class="btn">
          <a-button type="primary" @click="downLoadFile">
            下载合同
          </a-button>
        </div>
      </div>
    </a-modal>
    <!-- 多合同查看 -->
    <a-modal v-model="manyList" class="contractStyle" width="800px" :footer="null" :mask-closable="false">
      <div slot="title">
        <p><span class="text_title">选择合同</span> <span class="text_content">当前货主存在多份合同，请点击查看</span></p>
      </div>
      <div>
        <p v-for="text in contractList" :key="text.id" class="item_list">
          <span class="item_left">《{{text.title}}》 <span class="codestyle">{{text.bizId}}</span></span>
          <span class="item_right" @click="onLookContract(text)">点击查看</span>
        </p>
      </div>
    </a-modal>
    <!-- 签约多合同查看 -->
    <a-modal v-model="manyListSign" class="contractStyle" width="800px" :footer="null" :mask-closable="false">
      <div slot="title">
        <p><span class="text_title">选择合同</span> <span class="text_content">当前货主存在多份合同，请点击签约</span></p>
      </div>
      <div>
        <p v-for="text in contractListSign" :key="text.id" class="item_list">
          <span class="item_left">《{{text.contract.name}}》 <span class="codestyle">{{text.contract.code}}</span></span>
          <span v-if="text.contract.status === statusList.DRAFT" class="item_right" @click="onLookContractSign(text)">去签约</span>
          <span v-if="text.contract.status === statusList.ENABLED" class="item_right" @click="onLookContract(text)">去查看</span>
        </p>
      </div>
    </a-modal>
    <!-- 在线签约 -->
    <a-modal v-model="isSign" class="contractStyle" width="1200px" :footer="null" :mask-closable="false">
      <div slot="title">
        <p><span class="text_title">在线签约</span> <span class="text_content">货运合同已生成，完成合同签约即可下单</span></p>
      </div>
      <div class="contractBox">
        <div class="text">
          <iframe :src="iframeSignUrl" frameborder="0"></iframe>
        </div>
        <div class="btn">
          <a-button class="isSignBtn" @click="noSign">
            驳回
          </a-button>
          <a-button type="primary" @click="updataSign">
            确认签约
          </a-button>
        </div>
      </div>
    </a-modal>
    <!-- 拒绝签署 -->
    <a-modal v-model="refuse" class="contractStyle" width="536px" :footer="null" :mask-closable="false">
      <div slot="title">
        <p><span class="text_title">拒绝签署</span></p>
      </div>
      <div class="noMargin">
        <div class="text">
          <p class="refuseStyle">拒绝原因</p>
           <a-input
              v-model="remark"
              :max-length="100"
              :auto-size="{ minRows: 3, maxRows: 3 }"
              class="remark-input"
              placeholder="最多可输入100字"
              type="textarea" />
        </div>
        <div class="btn">
          <a-button type="primary" @click="toRefuse">
            确认
          </a-button>
          <a-button class="isSignBtn" @click="refuse=false">
            取消
          </a-button>
        </div>
      </div>
    </a-modal>
    <!-- 验证码输入 -->
    <a-modal v-model="verification" class="contractStyle" :footer="null" :mask-closable="false" @cancel="smsCancel">
      <div slot="title">
        <p><span class="text_title">请输入验证码</span></p>
      </div>
      <div class="smsDiv">
        <p>短信验证码发送至</p>
        <p class="phoneStyle">{{signData.legalMobile}}</p>
        <div>
          <a-input
            v-model="code"
            placeholder="请输入短信验证码"
            :max-length="6"
            class="suffix-right"
            @change="changeInput"
          >
            <div slot="suffix" class="countdown">
              <a-button class="code-btn" type="primary" :disabled="disabled" @click="getCode">
                <span v-if="!disabled">发送验证码</span>
                <a-statistic-countdown
                  v-else
                  :value="deadline"
                  format="重新发送ss秒"
                  @finish="timeFinish"
                />
              </a-button>
            </div>
          </a-input>
          <p v-if="flagSms" class="smsTips">请输入正确的验证码</p>
        </div>
        <div class="smsbtn">
          <a-button type="primary" :disabled="flagSms || nextFlag" @click="getFieldsValueData">
            确认
          </a-button>
          <a-button class="isSignBtn" @click="smsCancel">
            取消
          </a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import preview from 'vue-photo-preview'
// import DetailList from "../../components/tool/DetailList";
// import PageLayout from "../../layouts/PageLayout";
import qianyuesuccess from '@/assets/img/auth/pic_qianyuesuccess.png'
import qianyuewaiting from '@/assets/img/auth/pic_qianyuewaiting.png'
import qianyuenot from '@/assets/img/auth/pic_qianyuenot.png'
import { getSignType, getSignList, sendSignCode, contractPreview, getSignDetail, transcriptList, addSinger, transcriptSign, confirmChange } from '@/api/enterprise/authentication.js'
import https from '@/utils/http.js'
import moment from 'moment'
import InfoBox from "../orderManage/orderManageDetail/components/InfoBox.vue";
import { sessionDetail } from "./api/auth";
import { ContractStatusText } from "./constant";
import { ticketColumns, taxRateColumns } from "./fields"; 

import 'vue-photo-preview/dist/skin.css'


const option = {
   maxSpreadZoom: 2, // 控制预览图最大的倍数，默认是2倍，我这里改成了原图
   fullscreenEl: false, // 控制是否显示右上角全屏按钮
   closeEl: true, // 控制是否显示右上角关闭按钮
   tapToClose: false, // 点击滑动区域应关闭图库
   shareEl: false, // 控制是否显示分享按钮
   zoomEl: true, // 控制是否显示放大缩小按钮
   counterEl: false, // 控制是否显示左上角图片数量按钮
   arrowEl: true,  // 控制如图的左右箭头（pc浏览器模拟手机时）
   tapToToggleControls: false, // 点击应切换控件的可见性
   clickToCloseNonZoomable: false, // 点击图片应关闭图库，仅当图像小于视口的大小时
   bgOpacity: 0.7,
 }
Vue.use(preview, option)

// const DetailListItem = DetailList.Item;
const contractStatus = {
  NO_SIGN: 0,
  WAIT_SIGN: 1,
  ONLINE_SIGN: 2,
  OFFLINE_SIGN: 3,
  CAN_SIGN: 4,
}

const signText = ['未签约', '未签约', '线上签约完成', '线下签约', '待签约']
const statusList = {
    DRAFT: 'DRAFT',
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED'
}
const signProcess = ['NO_SIGN', 'WAIT_SIGN']
const STATUSES = ["CREATING","CREATE_FAILED","SIGNING","SIGNED","SUCCEEDED","SIGN_FAILED"]

export default {
  name: "BasicDetail",
  // components: { PageLayout, DetailListItem, DetailList, InfoBox },
  components: { InfoBox },
  data() {
    return {
      signText,
      statusList,
      authority: true,
      ContractStatusText,
      ticketColumns,
      taxRateColumns,
      baseInfo: {},
      contracts: [],
      visible: false,
      isSign: false,
      refuse: false,
      manyList: false,
      remark: '',
      imgList: [ qianyuenot,qianyuenot, qianyuesuccess, '', qianyuewaiting],
      verification: false,
      deadline: 0,
      disabled: false,
      signData: {
        realNameStatus: null
      },
      contractStatus,
      contractList: [], // 合同列表
      selectContract: {}, // 当前选中的合同
      iframeUrl: '',  // 合同预览地址
      authMessage: {}, // 认证信息
      code: '', // 验证码
      selectContractSign: '', // 选中的签约合同
      contractListSign: '', // 可选择的签约合同列表
      manyListSign: false,
      iframeSignUrl: '',
      flagSms: false,
      nextFlag: false,
      spinning: false,
      timer: null,
      isEnterprise:false,
      isShowSignType:true
    };
  },
  computed:{
    formatDate(){
      return (date)=>moment(date).format('YYYY-MM-DD')
    }
  },
  async mounted() {
    const {companyType,creditCode,customers}= this.$store.state.user
    if(creditCode){
     this.isShowSignType=customers.length===1
    }
    this.authority =companyType;
    this.isEnterprise=!!creditCode
    const { baseInfo, contracts } = await sessionDetail({ needContract: true });
    this.baseInfo = baseInfo;
    this.contracts = contracts;
    this.getSignType()
    this.authMessage = await getSignDetail({
      applyUserId: this.$store.state.user.userId
    })
  },
  methods: {
    smsCancel(){
      this.code = ''
      this.verification = false
      this.flagSms = false
    },
    changeInput(){
      if(this.code.length < 6){
        this.flagSms = true
      } else {
        this.flagSms = false
      }
    },
    filterData(data, blen){
      const len = data.length
      if(!len) return []
      let list = []
      const rlen = Math.round(len / 2)
      if(blen){
        list = data.slice(0, rlen)
      } else {
        list = data.slice(rlen, len)
      }
      return list
    },
    async getSignType(){
      // 获取签约状态
      let res = []
      const data={}
      const {creditCode,customers}=this.$store.state.user
      if(creditCode){
        data.ids=customers.map(item=>item.customerId)
      }else{
         data.ids=[this.$store.state.user.customerId]
      }
      res = await getSignType(data)
      if(res && res.length > 0){
        [this.signData] = res
      }
      if(this.signData.electronicContractStatus){
        clearInterval(this.timer)
        this.spinning = false
      }
    },
    async onLookContractSign(data){
      this.manyListSign = false
      this.isSign = true
      this.selectContractSign = data
      this.selectContract = data
      const res = await contractPreview({
        userContractId: data.contract.electronicCode,
        userId: this.$store.state.user.customerId,
      })
      if(res) {
        this.iframeSignUrl = res.url
      }
    },
    toRefuse(){
      this.spinning = true
      try {
        confirmChange({
          contractCodes: [this.selectContractSign.contract.electronicCode],
          status: 'CONFIRM_NOT_PASS',
          confirmReason: this.remark,
          operatorName: this.$store.state.user.userName,
          cargoOwnerId: this.$store.state.user.customerId
        }).then(() => {
          this.refuse = false
          this.spinning = false
          this.$message.success('提交成功')
        })
      } catch {
        this.spinning = false
      }
    },
    async getFieldsValueData(){
      if(this.code.length === 6){
        this.spinning = true
        this.nextFlag = true
        try {
          await transcriptSign({
            userId: this.$store.state.user.customerId,
            userContractId: this.selectContractSign.contract.electronicCode,
            code: this.code
          })
          this.nextFlag = false
          this.verification = false
          this.manyListSign = false
          this.$message.success('签约成功')
          this.timer = setInterval(this.getSignType, 1000)
        } catch {
          this.spinning = false
          this.nextFlag = false
        }
      }
    },
    updataSign(){
      this.isSign=false
      this.verification = true
    },
    downLoadFile(){
      https({
        data: {
          userId: this.$store.state.user.customerId,
          userContractId: this.selectContract.id, // 合同id
        },
        url: '/bfs_econtract/user/contract/download',
        service: 'BFS_USER_WEB_SERVER',
        name: '合同',
        type: 'pdf'
      })
    },
    timeFinish(){
      this.disabled = false
    },
    async getCode(){
      await addSinger({
        contractId: this.selectContractSign.contract.electronicCode,
        signer: this.$store.state.user.customerId
      })
      const res = await sendSignCode({
        contractId: this.selectContractSign.contract.electronicCode
      })

      if(res){
        this.$message.success("验证码发送成功");
        this.disabled = !this.disabled;
        this.deadline = Date.now() + 1000 * 60;
      }
    },
    getCustomerAddress({ provinceName, cityName, countyName, address }) {
      if (provinceName && cityName && countyName) {
        return `${provinceName}/${cityName}/${countyName}/${address}`;
      }
      return address;
    },
    async onLook(){
      this.contractList = await getSignList({
        userId: this.$store.state.user.customerId,
        statuses: STATUSES
      })
      if(this.contractList && this.contractList.length > 1){
        this.manyList = true
      } else if(this.contractList && this.contractList.length === 1) {
        [this.selectContract] = this.contractList
        const res = await this.contractDetail(this.contractList[0])
        if(res) {
          this.iframeUrl = res.url
          this.visible = true
        }
      }
    },
    async contractDetail(contract){
      const res = await contractPreview({
        userContractId: contract.id,
        userId: this.$store.state.user.customerId,
      })
      return res
    },
    async onLookContract(row){
      this.manyListSign = false
      this.manyList = false
      // 已签约合同只能查看和下载
      this.selectContract = row
      let data = {}
      if(row.contract){
        data = row.contract
      } else {
        data = row
      }
      if(data.electronicCode){
        data.id = data.electronicCode
      }
      const overRes = await this.contractDetail(data)
      if(overRes) {
        this.iframeUrl = overRes.url
        this.visible = true
      }
    },
    async toSign(){
      // 合同查询 与 预览
      const res = await transcriptList({
        cargoOwner: this.$store.state.user.customerCode,
        processType: ['NO_SIGN'],
      })
      let arr = []
      if(res && res.length > 0){
        arr = res.filter((e) => {
          return e.contract.status !== statusList.DISABLED && !signProcess.includes(e.contract.signProcess)
        })
      }
      if(arr && arr.length > 1){
        this.contractListSign = arr
        this.manyListSign = true
      } else if(arr && arr.length === 1){
        // 只有一个合同时
        [this.selectContractSign] = arr
        // 合同可签约
        if(this.selectContractSign.contract.status === statusList.DRAFT){
          this.isSign = true
          // this.getSignDetile()
          const signRes = await contractPreview({
            userContractId: this.selectContractSign.contract.electronicCode,
            userId: this.$store.state.user.customerId,
          })
          if(signRes) {
            this.iframeSignUrl = signRes.url
          }
        } else {
          // 合同已签约
          const data = this.selectContractSign.contract
          data.id = data.electronicCode
          const overRes = await this.contractDetail(data)
          if(overRes) {
            this.iframeUrl = overRes.url
            this.visible = true
          }
        }
      } else {
        this.$message.warning('暂无合同')
      }
    },
    // getSignDetile(){
    //   // 签约前合同pdf预览
    //   const that = this
    //   const http = new XMLHttpRequest();
    //   http.open("get", `${Service.BMS_WEB_PLUS_SERVER}/contract/export/pdf?contractCode=${this.selectContractSign.contract.code}`);
    //   http.responseType = "blob";
    //   http.setRequestHeader("Authorization", getToken());
    //   http.setRequestHeader("Content-Type", 'application/json');
    //   http.onreadystatechange = () => {
    //     if (http.status === 200 && http.readyState === 4) {
    //       const blob = new Blob([http.response], {
    //         type:
    //           "application/pdf;charset=UTF-8",
    //       });
    //       const csvUrl = URL.createObjectURL(blob);
    //       that.iframeSignUrl = csvUrl;
    //     }
    //   };
    //   http.send();
    // },
    noSign(){
      this.isSign = false
      this.refuse = true
    }
  },
};
</script>

<style lang="less" scoped>
.profile-table {
  margin-top: 24px;
  padding-bottom: 24px;
}
.title {
  color: @title-color;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;
}
.header {
  display: flex;
  align-items: center;
  line-height: 32px;
  &::before {
    content: "";
    width: 4px;
    height: 18px;
    border-radius: 2px;
    background-color: #06b880;
  }
  & > div {
    width: 100%;
  }
}
/deep/ .ant-card-body {
  padding: 30px 24px;
}
.dividerMargin {
  margin: 15px 0;
}
/deep/ .ant-table-column-title {
  font-weight: bold;
}
.InfoBox-root {
  padding: 28px 30px 0px 30px;
  border-radius: 0px;
  background: none;
}
.profile-info {
  margin-top: 15px;
  border-radius: 6px;
  background: #fff;
}
.text_div{
  padding-bottom: 24px;
}
.imgBox {
  width: 60px;
  height: 60px;
  .el-image{
    width: 60px;
    height: 60px;
  }
}
.noAuthority{
  height: calc(100vh - 200px);
  background: #fff;
  border-radius: 6px;
}
.tr{
  text-align: right;
  line-height: 50px;
}
.tl{
  text-align: left;
  line-height: 50px;
}
.infoStyle{
  /deep/ .ant-descriptions-item-label {
    // display: inline-block;
    width: 200px;
    text-align: right;
  }
}
.contractStyle{
  .text_title{
    font-size: 18px;
    color: #171717;
    font-weight: 600;
  }
  .text_content{
    font-size: 12px;
    color: #606266;
  }
  /deep/ .ant-modal-header{
    background-color: #F4F5F6 !important;
  }
  .contractBox{
    max-height: 550px;
    margin-bottom: 70px;
    position: relative;
    .text{
      overflow-y: scroll;
      height: 500px;
    }
    .btn{
      width: 100%;
      height: 54px;
      text-align: center;
      position: absolute;
      bottom: -54px;
      left: 0;
      border-top: 1px solid #F5F6F7;
      button{
        width: 400px;
        margin-top: 15px;
        height: 54px;
      }
      .isSignBtn{
        width: 120px;
        margin-right: 32px;
      }
    }
    .deflutbtn{
      button{
        margin-left: 8px;
      }
    }
    .remark-input{
      margin: 16px 0 0 0;
    }
  }
  .noMargin{
    margin-bottom: 0;
    height: 175px;
    .btn{
      width: 100%;
      height: 54px;
      text-align: center;
      position: absolute;
      left: 0;
      bottom: 12px;
      border-top: 1px solid #F5F6F7;
      button{
        width: 58px;
        margin-top: 15px;
        height: 32px;
        float: right;
        margin-right: 16px;
      }
      .isSignBtn{
        width: 58px;
        margin-right: 8px;
        float: right;
      }
    }
  }
}
.item_list{
  height: 48px;
  line-height: 48px;
  .item_left{
    font-size: 14px;
    color: #171717;
    font-weight: 600;
  }
  .item_right{
    font-size: 12px;
    color: #06B880;
    float: right;
    &:hover{
      cursor: pointer;
    }
  }
}
.sign_div{
  padding-bottom: 24px;
  margin-top: 20px;
  .text_ok{
    margin: 0 16px 0 24px;
    font-size: 14px;
    font-weight: 600;
    color: #171717;
  }
  .text_btn{
    border-color: #06B880;
    color: #06B880;
  }
}
.suffix-right {
  ::v-deep {
    .ant-input-suffix {
      right: 0px;
      display: inline-block;
    }
    .ant-statistic-content {
      color: #fff;
    }
    .ant-statistic-content-value{
      display: block;
      font-size: 14px;
    }
    .ant-btn-primary[disabled]{
      background-color: rgba(6, 184, 128, 0.5);
    }
  }
}
.phoneStyle{
  margin: 8px 0 16px 0;
  font-size: 24px;
  font-weight: bold;
  color: #171717;
}
iframe{
  width: 100%;
  height: 100%;
}
.refuseStyle{
  margin-bottom: 20px;
}
.smsDiv{
  height: 200px;
}
.smsbtn{
  width: 100%;
  height: 54px;
  text-align: center;
  position: absolute;
  left: 0;
  bottom: 12px;
  border-top: 1px solid #F5F6F7;
  button{
    width: 58px;
    margin-top: 15px;
    height: 32px;
    float: right;
    margin-right: 16px;
  }
  .isSignBtn{
    width: 58px;
    margin-right: 8px;
    float: right;
  }
}
.codestyle{
  font-weight: 400;
}
.smsTips{
  color: red;
  margin-top: 5px;
}
</style>
